var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsights(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.7502 16.6855C40.7293 16.6855 39.0418 19.6855 39.7293 21.9147L32.3335 29.3314C31.7085 29.1439 30.7918 29.1439 30.1668 29.3314L24.8543 24.0189C25.5627 21.7897 23.8752 18.7689 20.8335 18.7689C17.8127 18.7689 16.1043 21.7689 16.8127 24.0189L7.31266 33.498C5.0835 32.8105 2.0835 34.498 2.0835 37.5189C2.0835 39.8105 3.9585 41.6855 6.25016 41.6855C9.271 41.6855 10.9585 38.6855 10.271 36.4564L19.7502 26.9564C20.3752 27.1439 21.2918 27.1439 21.9168 26.9564L27.2293 32.2689C26.521 34.498 28.2085 37.5189 31.2502 37.5189C34.271 37.5189 35.9793 34.5189 35.271 32.2689L42.6877 24.873C44.9168 25.5605 47.9168 23.873 47.9168 20.8522C47.9168 18.5605 46.0418 16.6855 43.7502 16.6855Z",
    fill: "#303030"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2502 18.7695L33.2085 14.457L37.5002 12.5195L33.2085 10.582L31.2502 6.26953L29.3335 10.582L25.0002 12.5195L29.3335 14.457L31.2502 18.7695ZM7.29183 22.9362L8.3335 18.7695L12.5002 17.7279L8.3335 16.6862L7.29183 12.5195L6.25016 16.6862L2.0835 17.7279L6.25016 18.7695L7.29183 22.9362Z",
    fill: "#303030"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsights);
export default __webpack_public_path__ + "static/media/insights.bfd29bb10e8b937691ad5aa3c8c22cfc.svg";
export { ForwardRef as ReactComponent };